import { api } from "boot/axios";

export const getTabDocument = async ({commit}, form) => {
  try {
    const resp = await api.post('/sunat/user/filter/', form)
    commit('setTabDocument', resp.data)
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(error)
  }
}

